<template>
  <guides-page v-if="enabled"/>
  <legacy-main v-else/>
</template>

<script>
import { mapState } from 'vuex';
import { isEnabled as isInsuranceBillingEnabled } from '@/app/billing/guide/service';
import GuidesPage from './Guides.vue';
import LegacyMain from './legacy/Main.vue';

export default {
  components: {
    GuidesPage,
    LegacyMain,
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
    enabled() {
      return isInsuranceBillingEnabled(this.user);
    },
  },
};
</script>
